// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Zap_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M20.23 11.078a.75.75 0 0 0-.468-.53L14.36 8.522l1.374-6.875a.75.75 0 0 0-1.283-.656l-10.5 11.25a.75.75 0 0 0 .28 1.219l5.404 2.026-1.371 6.867a.75.75 0 0 0 1.283.656l10.5-11.25a.75.75 0 0 0 .182-.68Zm-9.977 8.985.982-4.911a.75.75 0 0 0-.469-.85l-4.953-1.86 7.933-8.5-.981 4.91a.75.75 0 0 0 .469.85l4.95 1.856Z',
  viewBox: '0 0 24 24',
  glyph: 'Zap_Stroke2_Corner0_Rounded',
})
